var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#848484"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8232_1078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.4167 15.8627C13.4167 15.2143 13.6743 14.5925 14.1328 14.134C14.5913 13.6755 15.2131 13.418 15.8615 13.418H23.8053C24.1264 13.418 24.4443 13.4812 24.7409 13.6041C25.0375 13.7269 25.307 13.907 25.534 14.134C25.761 14.361 25.9411 14.6305 26.064 14.9272C26.1868 15.2238 26.2501 15.5417 26.2501 15.8627V23.8066C26.2501 24.1276 26.1868 24.4455 26.064 24.7421C25.9411 25.0387 25.761 25.3082 25.534 25.5353C25.307 25.7623 25.0375 25.9423 24.7409 26.0652C24.4443 26.1881 24.1264 26.2513 23.8053 26.2513H15.8615C15.5404 26.2513 15.2225 26.1881 14.9259 26.0652C14.6293 25.9423 14.3598 25.7623 14.1328 25.5353C13.9058 25.3082 13.7257 25.0387 13.6028 24.7421C13.48 24.4455 13.4167 24.1276 13.4167 23.8066V15.8627Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6777 22.3422C10.3966 22.182 10.1627 21.9504 9.99986 21.6708C9.83697 21.3912 9.75078 21.0736 9.75 20.75V11.5833C9.75 10.575 10.575 9.75 11.5833 9.75H20.75C21.4375 9.75 21.8115 10.1029 22.125 10.6667",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8232_1078"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(7 7)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCopy);
export default __webpack_public_path__ + "static/media/ic-copy.e7dfb8968645ae7d1a4e68d0de5f8359.svg";
export { ForwardRef as ReactComponent };